import React from 'react';
import { GridOverlay } from "@material-ui/data-grid";

export const DataGridLoadingOverlay = () => (
    <GridOverlay>
        <h6 style={{ textAlign: "center" }}>Loading...</h6>
    </GridOverlay>
);